
















































































import { Component, Vue, Prop, PropSync, Watch } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import { email, integer, minLength, numeric, required, requiredIf } from 'vuelidate/lib/validators';
import vSelect from 'vue-select';
import { AddressApi, OrgsApi, ProductsApi, SitesApi, UsersApi } from '../../api';
import SiteSuggest from '@/components/form pickers/siteSuggest.vue';
import addressSuggest from '@/components/form pickers/adrSuggest.vue';
import Toast from '@/components/display/toast.vue';
import { ApiUtils } from '@/common/ApiUtils';

@Component({
	components: {
		addressSuggest,
		SiteSuggest,
		vSelect,
		Toast,
	},
	validations: {
		localSite: {
			name: { required },
			address: {
				fullAdr: {
					required: requiredIf(function() {
						return typeof this.org.id != 'number';
					}),
				},
				rawAddress: {
					required: requiredIf(function() {
						return typeof this.org.id != 'number';
					}),
				},
				location: {
					required: requiredIf(function() {
						return typeof this.org.id != 'number';
					}),
				},
			},
		},
	},
	mixins: [validationMixin],
})
export default class AddSite extends Vue {
	public existingOrg = false;
	public existingUser = false;
	public existingSite = false;
	public emailRequired = true;
	public billingRequired = true;
	public loading = false;

	@PropSync('org') public localOrg!: object;

	@PropSync('site') public localSite!: object;

	@Prop({ type: Boolean, default: false })
	public submitOnSiteComponent: boolean;

	public siteList = [];
	private toast: Toast = new Toast();
	public submitStatus: 'ERROR' | 'PENDING' | 'OK' | null = null;
	public region: any = null;
	public siteRegion: any = null;

	@Watch('site')
	public onSiteChange() {
		if (this.localOrg) {
			this.localOrg.sites.map((site: { id: any }) => this.siteList.push(site.id));
		}
	}

	public isValid(field) {
		return field && field.$dirty ? !field.$invalid : null;
	}

	public stepValidate(name: string) {
		const form = this.$v[name];
		form.$touch();
		if (!form.$invalid && this.submitOnSiteComponent) {
			this.onComplete();
		} else if (!form.$invalid) {
			this.$emit('nextTab');
		}
	}

	public async onComplete(...a: any[]) {
		this.submitStatus = 'PENDING';

		if (!this.siteList.includes(this.site.id)) {
			try {
				let lat, lng;
				if (this.localSite.latitude && this.localSite.longitude) {
					lat = this.localSite.latitude;
					lng = this.localSite.longitude;
				} else {
					lat =
						typeof this.localSite.address.rawAddress.geometry.location.lat === 'function'
							? this.localSite.address.rawAddress.geometry.location.lat()
							: this.localSite.address.rawAddress.geometry.location.lat;
					lng =
						typeof this.localSite.address.rawAddress.geometry.location.lng === 'function'
							? this.localSite.address.rawAddress.geometry.location.lng()
							: this.localSite.address.rawAddress.geometry.location.lng;
				}
				const promise = await new SitesApi().addSite({
					data: {
						orgId: this.localOrg.id,
						name: this.localSite.name,
						latitude: lat,
						longitude: lng,
					},
				});
				this.localOrg.activeSiteId = promise.data.data.id;
				this.localSite.id = promise.data.data.id;
				this.siteList.push(promise.data.data.id);
			} catch (e) {
				const { errorMessage } = ApiUtils.handleApiError(e, 'Error adding site');
				this.toast.makeToast(errorMessage, 'Error adding site', 'danger');
				this.submitStatus = 'ERROR';
				return;
			}
			new Toast().makeToast('Site added to org', 'Site Added', 'success');

			if (!(this.localSite.latitude && this.localSite.longitude)) {
				try {
					await new AddressApi().addAddress({
						data: {
							ownerType: 'sites',
							ownerId: this.localSite.id,
							type: 'street',
							rawAddress: this.localSite.address.rawAddress,
						},
					});
				} catch (e) {
					const { errorMessage } = ApiUtils.handleApiError(e, 'Address not created');
					this.toast.makeToast(errorMessage, 'Address not created', 'danger');
					return;
				}
			}

			this.$emit('nextTab');
		} else {
			new Toast().makeToast('Site already exists on org', 'Site Exists', 'success');
			this.localOrg.activeSiteId = this.localSite.id;
			this.$emit('nextTab');
		}
		this.submitStatus = 'OK';

		this.$emit('load');
	}
}
